export interface RedRuleProps {
  /** Numeric pixels or 'full' for 100% of parent. */
  width: number | 'full';
  /** When true, sets data-animated="true" so beta.css plays red-rule-draw. */
  animated?: boolean;
}

/** 1px horizontal red divider. */
export function RedRule({ width, animated }: RedRuleProps) {
  return (
    <span
      aria-hidden="true"
      data-animated={animated ? 'true' : undefined}
      style={{
        display: 'inline-block',
        height: '1px',
        width: width === 'full' ? '100%' : `${width}px`,
        background: 'var(--vm-red)',
      }}
    />
  );
}
